import { Button } from '@components';

import styles from './BuildCustomization.module.scss';

export default function ContinueButton(pageProps) {
  const { clicked, locale, formMode } = pageProps;
  const text = formMode === 'summary' ?
    (locale == 'fr' ? 'Sommaire' : 'Summary') :
    (locale == 'fr' ? 'Sommaire' : 'Summary')

  return (
    <Button
      className={styles.continueBtn}
      onClick={clicked}
    >
      {text}
    </Button>
  );
}
